import { useQuery } from '@tanstack/react-query';
import { getTimetable } from '@/api/student';
import { Card } from '@/components/ui/Card';
import { PageHeader, QueryState } from '@/components/kit/ui';
import { asList, unwrap } from '@/components/kit/data';
import { DAYS, NotInClass, todayIso, type TimetableRow } from '../shared';

export function TimetablePage() {
  const q = useQuery({ queryKey: ['student-timetable'], queryFn: () => getTimetable().then((r) => asList<TimetableRow>(unwrap(r))), retry: false });
  const rows = q.data ?? [];
  const days = [...new Set(rows.map((r) => r.weekday))].sort();
  const today = todayIso();
  return (
    <div className="space-y-4">
      <PageHeader title="Timetable" subtitle="Your class periods for the week." />
      <NotInClass error={q.error}>
        <QueryState q={q} isEmpty={!rows.length} empty="Your class timetable has not been published yet.">
          <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
            {days.map((d) => (
              <Card key={d} title={`${DAYS[d]}${d === today ? ' (today)' : ''}`}>
                <ul className="divide-y text-sm">
                  {rows.filter((r) => r.weekday === d).sort((a, b) => a.period - b.period).map((e) => (
                    <li key={e.id} className="py-2 flex justify-between gap-3">
                      <span><b>{e.subject ?? (e.kind === 'break' ? 'Break' : e.kind ?? 'Free')}</b>{e.teacher && <span className="block text-xs text-slate-500">{e.teacher}{e.room ? ` · ${e.room}` : ''}</span>}</span>
                      <span className="text-slate-500 font-mono text-xs shrink-0">{e.starts_at}–{e.ends_at}</span>
                    </li>
                  ))}
                </ul>
              </Card>
            ))}
          </div>
        </QueryState>
      </NotInClass>
    </div>
  );
}
